module.exports = __webpack_public_path__ + "img/rank_colonel.fb2d8b17.svg";